import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  className: string;
  children?: React.ReactNode;
}

export const FltDptCategoryItem = styled.li<IProps>`
  position: relative;

  .btn-text {
    ${mixin.flex({ justify: 'flex-start' })}
    width: 100%;
    height: 37px;
    position: relative;
    z-index: 0;

    .text {
      font-size: 16px;
      font-weight: 500;
      line-height: 130%;
      color: #000;
      text-align: left;
    }

    .cnt {
      font-size: 15px;
      font-weight: 500;
      line-height: 130%;
      color: #bbb;
      margin-left: 4px;
      max-width: none;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    .btn-text {
      height: ${mixin.pxToVw('37')};

      .text {
        font-size: ${mixin.pxToVw('16')};
      }

      .cnt {
        font-size: ${mixin.pxToVw('15')};
        margin-left: ${mixin.pxToVw('4')};
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    .btn-text {
      height: 38px;

      .text {
        font-size: 17px;
      }

      .cnt {
        font-size: 16px;
        margin-left: 6px;
      }
    }
  }
`;
